<style scoped>

</style>
<template>
  <div>
    <div class="line text-center">
      <Select
        v-model.number="params.company_id"
        placeholder="公司"
        style="width: 100px"
        @on-change="doSearch"
      >
        <Option :value="0">
          所有公司
        </Option>
        <Option
          v-for="company in companies"
          :key="company.id"
          :value="company.id"
        >
          {{ company.short_name }}
        </Option>
      </Select>
    </div>
    <div class="line text-center">
      <Button
        type="primary"
        icon="md-add"
        @click="addIncomeGroup()"
      >
        添加
      </Button>
      <space />
      <i-input
        v-model="params.search"
        placeholder="输入关键字搜索"
        style="width: 180px"
        @on-enter="doSearch()"
      />
      <space />
      <Ajaxbtn
        ref="searchBtn"
        :url="get_income_groups_path"
        :params="params"
        type="search"
        @before="beforeSearch"
        @done="handleIncomeGroupData"
        @fail="handleIncomeGroupFail"
        @finally="loading = false"
      />
    </div>
    <div class="list-container">
      <Table
        size="small"
        :columns="columns"
        :data="income_groups"
        :loading="loading"
      />
    </div>

    <div
      v-show="page_info.total"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="page_info.current"
        :total="page_info.total"
        :page-size="page_info.page_size"
        @on-change="pageChange"
      />
    </div>

    <Editor
      ref="editor"
      :type="type"
      @update="updateIncomeGroup"
    />
  </div>
</template>
<script>
  import ExpenseUtil from '../../libs/expense_util';
  import Uid from './components/uid';
  import Editor from './components/editor';
  import CustomerSelector from '../components/customer/selector';
  import PayeeCompanySelector from '../payee_company/components/selector';
  import UserFlowBase from '../components/flow/user_flow_base';
  import {mapGetters} from "vuex";

  export default {
    components: { Uid, Editor, CustomerSelector, PayeeCompanySelector, UserFlowBase },
    props: {
      type: {
        type: Number,
      },
    },
    data() {
      return {
        loading: false,
        params: {
          per_page: 10,
          page: 1,
          search: '',
          company_id: 0,
          receipt_type: this.type,
        },
        page_info: {
          current: 1,
          total: 0,
          page_size: 10
        },
        income_groups: [],
        columns: [
          // {
          //   title: '展开',
          //   type: 'expand',
          //   align: 'center',
          //   minWidth: 36,
          //   render: (h, params) => {
          //     return h(IncomeGroupExpand, {
          //       props: {
          //         type: this.type,
          //         model_id: params.row.id,
          //         canEdit: true
          //       }
          //     })
          //   }
          // },
          {
            title: '编号',
            key: 'uid',
            minWidth: 120,
            align: 'center',
            render: (h, params) => {
              return <Uid income_group={ params.row } />
            }
          },
          {
            title: '名称',
            key: 'name',
            minWidth: 120,
            align: 'center',
          },
          {
            title: '单位类型',
            minWidth: 120,
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              const unit_type = this.unit_types_hash[row.unit_type];
              return h('span', unit_type ? unit_type.name : '-');
            }
          },
          {
            title: '往来单位',
            minWidth: 120,
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              if (row.unit_type === 'BD_customer') {
                const client = this.clients_hash[row.client_id];
                return h('span', client ? client.name : '-');
              } else if (row.unit_type === 'BD_Empinfo') {
                return <CustomerSelector value={ row.staff_id } searchable={ false } />
              } else if (row.unit_type === 'BD_Supplier') {
                return <PayeeCompanySelector value={ row.payee_company_id } searchable={ false } />
              }
              return h('span', '未定义往来单位');
            }
          },
          {
            title: '金额',
            minWidth: 120,
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              const symbol = ExpenseUtil.getCurrencySymbol(row.currency);
              return h('span', symbol + this.$util.formatPrice(row.total_price));
            }
          },
          {
            title: '状态',
            minWidth: 130,
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              const user_flow = row.user_flow;
              return h(UserFlowBase, {
                props: {
                  user_flow: user_flow,
                  model: row,
                }
              })
            }
          },
          {
            title: '状态',
            minWidth: 80,
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              // const user_flow = row.user_flow;
              return (
                <Dropdown
                  trigger="click"
                  placement="left"
                  vOn:on-click={ (event_name) => { this.handleEvent(event_name, row, params.index) } }
                >
                  <span class="link">
                    操作
                    <Icon type="ios-arrow-down" />
                  </span>
                  <DropdownMenu slot="list">
                    <DropdownItem name="edit">编辑</DropdownItem>
                    <DropdownItem name="delete" divided>废弃</DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              )
            }
          }
        ]
      }
    },
    computed: {
      get_income_groups_path() {
        return this.$util.api.es_query_income_group;
      },
      cur_customer() {
        return this.$store.state.cur_customer;
      },
      ...mapGetters({
        receipt_bill_types: 'async/receipt_bill_types',
        receipt_purposes: 'async/receipt_purposes',
        unit_types_hash: 'async/unit_types_hash',
        clients_hash: 'async/clients_hash',
        companies: 'async/companies',
        companies_hash: 'async/companies_hash',
        teams: 'async/root_teams',
        teams_hash: 'async/root_teams_hash',
        expense_types: 'async/expense_types',
        expense_types_hash: 'async/expense_types_hash',
      }),
    },
    created() {
      //
    },
    mounted() {
      this.doSearch();
    },
    methods: {
      addIncomeGroup() {
        this.$refs.editor.edit();
      },
      editIncomeGroup(income_group) {
        this.$refs.editor.edit(income_group);
      },
      beforeSearch() {
        this.params.page = 1;
        this.loading = true;
      },
      pageChange(new_page) {
        this.loading = true;
        this.params.page = new_page;
        this.$refs.searchBtn.doAjax(true);
      },
      doSearch() {
        this.params.page = 1;
        this.$refs.searchBtn.doAjax();
      },
      handleIncomeGroupData(data) {
        this.income_groups = data.income_groups;
        this.page_info.current = data.cur_page;
        this.page_info.page_size = data.per_page;
        this.page_info.total = data.total_count;
      },
      handleIncomeGroupFail(e) {
        this.$Modal.error({title: '提示', content: e.message});
      },
      updateIncomeGroup(income_group) {
        if (income_group.user_flow) {
          this.$util.insertOrUpdateArrayItem(this.income_groups, income_group, true);
        } else {
          this.doSearch();
        }
      },
      deleteIncomeGroup(income_group) {
        let del_reason = '';
        this.$Modal.confirm({
          title: '提示',
          render: (h) => {
            return h('div', [
              h('div', {
                class: {
                  'line': true,
                  'color-error': true
                }
              }, `你确定要废弃 ${income_group.name} 吗?`),
              h('Input', {
                props: {
                  value: del_reason,
                  type: 'textarea',
                  maxlength: 200,
                  autofocus: true,
                  placeholder: '请输入废弃的原因'
                },
                on: {
                  input: (val) => {
                    del_reason = val;
                  }
                }
              })
            ]);
          },
          onOk: () => {
            if (!del_reason.trim()) {
              this.$Message.error('请输入废弃的原因?');
              setTimeout(() => {
                this.deleteIncomeGroup(income_group);
              }, 500);
              return;
            }
            this.$util.ajax.post(this.$util.api.delete_income_group, {
              id: income_group.id,
              del_reason: del_reason
            }).then((response) => {
              return response.data;
            }).then((res) => {
              if (res.code === 1) {
                income_group.del = true;
                this.$Message.success('废弃成功!');
              } else {
                this.$Modal.error({title: '提示', content: res.msg});
              }
            }).catch((e) => {
              this.$Modal.error({title: '提示', content: e.message});
            });
          }
        })
      },
      handleEvent(event_name, income_group, index) {
        console.log(event_name, income_group, index);
        switch (event_name) {
          case 'edit':
            this.editIncomeGroup(income_group);
            break;
          case 'delete':
            this.deleteIncomeGroup(income_group);
            break;
          default:
            this.$Message.error('未定义操作!');
            break;
        }
      }
    }
  }
</script>
